import { getCookie, setCookie, delCookie } from './cookie';

//获取cookie中存储的之前选中的产品信息
export let getCheckedCookie = () => {
    let cartIds = decodeURIComponent(getCookie('recently_purchased_key')), cartIdsArr = [];

    if(cartIds){
        cartIds = cartIds.replace(new RegExp('"', "g"),'');
        cartIds = cartIds.split(',');
        cartIds.forEach((item)=>{
            let items = item.split('_');
            cartIdsArr.push(items[0]);
        })
    }
    return cartIdsArr;
}

//更新cookie中存储的选中的产品信息
export let updateCheckedCookie = (checkedItems) => {
    if(checkedItems.length > 0){
        setCookie('recently_purchased_key', encodeURIComponent(checkedItems.join(',')), '');
    }else{
        delCookie('recently_purchased_key');
    }  
}